// 活动助手（收徒）
export const URI_ASSISTALIVE = '/s1/assist.alive'
